import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { MOCKUP_URL, recentBuyers } from '../data/content';
type Buyer = {
  name: string;
  country: string;
  minutes: number;
};
function pick(prev?: Buyer): Buyer {
  let b = recentBuyers[Math.floor(Math.random() * recentBuyers.length)];
  while (prev && b.name === prev.name) {
    b = recentBuyers[Math.floor(Math.random() * recentBuyers.length)];
  }
  return {
    ...b,
    minutes: 1 + Math.floor(Math.random() * 9)
  };
}
export function PurchasePopup() {
  const [buyer, setBuyer] = useState<Buyer | null>(null);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setBuyer(prev => pick(prev ?? undefined));
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 15000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed inset-x-3 bottom-[92px] z-50 md:inset-x-auto md:bottom-6 md:left-6 md:w-[360px]" aria-live="polite" data-id="element-36" data-mp="1fxvcnk8c97r3">
      <AnimatePresence data-id="element-37" data-mp="n6born0sr5ir">
        {open && buyer && !dismissed && <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_16px_40px_rgba(4,16,31,0.35)] ring-1 ring-mist-200" data-id="element-38" data-mp="i81sta7900w3">
            <img src={MOCKUP_URL} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-mist-50 object-contain" data-id="element-39" data-mp="23m6asfmngtbo" />
            <div className="min-w-0" data-id="element-40" data-mp="2anrvj5w77ahy">
              <p className="text-sm font-extrabold text-ink-900" data-id="element-41" data-mp="2aqxlencnigeq">
                {buyer.name} <span className="font-semibold text-mist-600" data-id="element-42" data-mp="2fltezrxjdbty">from {buyer.country}</span>
              </p>
              <p className="text-[13px] leading-snug text-ink-700" data-id="element-43" data-mp="2kniubjrskbnu">just purchased the Retreatment Decision Blueprint™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-brand-700" data-id="element-44" data-mp="1ry3gyncnm6or">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-45" data-mp="1wx6abaj9uogw" />
                Verified purchase · {buyer.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-mist-500 hover:bg-mist-100 hover:text-ink-900" aria-label="Close notification" data-id="element-46" data-mp="21uyf3550m52i">
              <XIcon className="h-4 w-4" data-id="element-47" data-mp="1e5du6gpawxql" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}